import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const StaffologyPortal = ({ user }) => {
  const navigate = useNavigate();
  
  // Directly redirect to Staffology in new tab and go home
  useEffect(() => {
    window.open('https://app.staffologyhr.co.uk/portal/logoff.aspx', '_blank');
    navigate('/');
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#ededed' }}>
      <div className="text-center">
        <p className="text-lg font-semibold" style={{ color: '#1d1d1b' }}>
          Redirecting to Staffology...
        </p>
      </div>
    </div>
  );
};

export default StaffologyPortal;
